module.exports = __webpack_public_path__ + "static/media/component-close.6de69f16.svg";